export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-transparent border-t border-white/10 text-white py-20 mt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <h2 className="font-display text-[0.9375rem] sm:text-lg tracking-tight max-w-2xl leading-tight">
          Pour plus d'informations contactez-nous : <a href="mailto:artmoneygroup44@gmail.com" data-testid="footer-contact-email" className="text-[#D4AF37] hover:underline">artmoneygroup44@gmail.com</a>
        </h2>
        <div className="mt-14 flex flex-col md:flex-row justify-between gap-8 border-t border-white/10 pt-8">
          <p className="text-white/60 text-sm">© {new Date().getFullYear()} Art Money Group. Tous droits réservés.</p>
          <p className="text-white/60 text-sm">Paiement sécurisé via Stripe</p>
        </div>
      </div>
    </footer>
  );
};
